import { createInertiaApp } from '@inertiajs/react';
import { createElement, ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { PageProps } from '@/types';
import Layout from '../components/Layout';
import BlankLayout from '../components/BlankLayout';
import { UserProvider } from '../src/context/UserContext';

type PageComponent<P = {}> = React.FC<P> & {
  layout?: (page: ReactNode) => ReactNode;
  useBlankLayout?: boolean;
};

document.addEventListener('turbo:load', () => {
  const app = document.getElementById('app');
  const isErbPage = document.getElementById('react-layout') !== null;

  if (!app) {
    console.warn('⚠️ Skipping Inertia: No #app found. This is a non-Inertia page.');
    return;
  }

  console.log('✅ Inertia mounting on #app...');

  createInertiaApp({
    resolve: (name) => {
      const pages = import.meta.glob<{
        default: PageComponent<PageProps>;
      }>('../pages/**/*.tsx', { eager: true });

      const importedPage = pages[`../pages/${name}.tsx`];

      if (!importedPage) {
        console.error(`❌ Missing Inertia page component: '${name}.tsx'`);
        throw new Error(`Missing Inertia page: ${name}`);
      }

      const Page = importedPage.default as PageComponent<PageProps>;

      // In your Inertia setup
      if (!isErbPage && !Page.layout) {
        Page.layout = (page) => createElement(Layout, { children: page });
      }

      return Page;
    },

    setup({ el, App, props }) {
      createRoot(el!).render(
        createElement(UserProvider, {
          children: createElement(App, props),
        }),
      );
    },
  });
});
